var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.832 13.4H4.005c-1.878 0-2.817 0-3.21-.615-.394-.616 0-1.468.79-3.172l3.642-7.866C5.726.669 5.975.13 6.237.187c.261.058.261.652.261 1.84v5.906c0 .314 0 .472.098.57.097.097.255.097.569.097h1.827c1.878 0 2.817 0 3.21.615.393.616-.001 1.468-.79 3.172L7.77 20.253c-.5 1.078-.748 1.617-1.01 1.559s-.262-.651-.262-1.839v-5.906c0-.315 0-.472-.097-.57-.098-.097-.255-.097-.57-.097"
})));
export default SvgLightning;